import ListingVM from './listing-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    console.log('Kadenze.StudentSessionListing initialization function called');
    let vm = new Vue(ListingVM);
    vm.bindData(JSON.parse(element.dataset.lecturesJson));
    vm.$mount(element);
  }
};

